import React, { Component } from 'react'

export default class ListofPracticeComponent extends Component {
    constructor(props){
        super(props)
        this.state={
            Practice:[]
        };
    }
    componentDidMount(){
      fetch("https://localhost:44334/api/Practice")
      .then(res=>res.json())
      .then(result => {
              this.setState({Practice:result});
                 }
      )
     
    }
    render() {
        return (
            <div>
                <h1>Practice Detail</h1>
                <table>
                    <thead>
                        <th>
                         Id
                        </th>
                        <th>
                        PracticeDescription
                        </th>
                        <th>
                        subject
                        </th>
                    </thead>
                    <tbody>
                        {this.state.Practice.map( pra => (
                        <tr Key={pra.Id}>
                            <td>{pra.Id}</td>
                            <td>{pra.PracticeDescription}</td>
                            <td>{pra.subject}</td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )
    }
}
